import { createClient, SupabaseClient } from '@supabase/supabase-js';

/**
 * Returns the Supabase config variables and basic validation.
 */
export function getSupabaseConfig() {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
  return {
    supabaseUrl,
    supabaseAnonKey,
    isConfigured:
      !!supabaseUrl &&
      !!supabaseAnonKey &&
      supabaseUrl !== 'your-supabase-url' &&
      supabaseAnonKey !== 'your-supabase-anon-key' &&
      supabaseUrl.startsWith('http') &&
      supabaseAnonKey.length > 20, // JWT length basic check
    diagnostics: {
      hasUrl: !!supabaseUrl,
      hasKey: !!supabaseAnonKey,
      urlValid: supabaseUrl.startsWith('http'),
      keyValid: supabaseAnonKey.length > 20,
    }
  };
}

// Environment-safe logging
if (process.env.NODE_ENV !== 'production') {
  const config = getSupabaseConfig();
  console.log('Supabase config check:', config.diagnostics);
  if (!config.isConfigured) {
    console.error(
      'Supabase is not properly configured. Please check your environment variables.',
      'Required: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY'
    );
  }
}

/**
 * Safely exports Supabase client only if configured.
 * Throws an error if used without proper config.
 */
export const supabase: SupabaseClient = (() => {
  const config = getSupabaseConfig();
  if (!config.isConfigured) {
    throw new Error('Supabase is not configured — aborting creation of Supabase client.');
  }
  return createClient(config.supabaseUrl, config.supabaseAnonKey);
})();

/**
 * Returns whether Supabase config is valid (for use in conditional app logic/views).
 */
export const isSupabaseConfigured = () => getSupabaseConfig().isConfigured;
